// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__3QnjH","info":"Note_info__1Vvyv","note":"Note_note__IAQH_","actions":"Note_actions__2tyoJ"};